import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';
import {PlusIcon, TrashIcon} from 'shells/icon';

import {AddSubdomainModal} from './add-subdomain-modal';

type Props = {
    domainName: string;
    onDeleteDomain: () => Promise<any>;
    toggleRowExpanded: (arg1: boolean) => void;
};

export function DomainRowActionMenu(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const [isAddingSubdomain, setIsAddingSubdomain] = React.useState<boolean>(false);
    const actionMenuRef = React.useRef();

    return (
        <>
            <ActionMenu
                options={[
                    {
                        label: 'Add subdomain',
                        handleSelect: () => setIsAddingSubdomain(true),
                        icon: <PlusIcon size={16} />,
                    },
                    {
                        label: 'Delete',
                        handleSelect: () => setIsConfirmingDelete(true),
                        icon: <TrashIcon size={16} />,
                        variant: 'destructive',
                    },
                ]}
                getRef={(node) => {
                    // @ts-expect-error
                    actionMenuRef.current = node;
                }}
            />
            {isConfirmingDelete && (
                <ConfirmationDialog
                    title='Are you sure you want to delete this domain?'
                    message='Any landing pages currently hosted on this domain will no longer be accessible through their custom URLs.'
                    onCancel={() => setIsConfirmingDelete(false)}
                    onConfirm={() => {
                        props.onDeleteDomain().then(() => setIsConfirmingDelete(false));
                    }}
                />
            )}
            {isAddingSubdomain && (
                <AddSubdomainModal
                    domain={props.domainName}
                    setIsAddingSubdomain={setIsAddingSubdomain}
                    toggleRowExpanded={props.toggleRowExpanded}
                />
            )}
        </>
    );
}
